import app from './app'
import certificate from './certificate'
import node from './node'
import home from './home'
import chain from './blockchain'
import system from './system'
import camanage from './camanage'
import configmanage from './configmanage'
import excellent from './excellent'
import oracleManagement from './oracleManagement'
import expansionDemo from './expansionDemo'
import datamigration from './datamigration'
import crossChain from './crossChain'
import contractdetector from './contractdetector'
import encryption from './encryption'
import hibe from './hibe'
import bulletproofs from './bulletproofs'
import chatrobot from './chatrobot'
import spvlightnodes from './spvlightnodes'
import agileTest from './agileTest'
import privacy from './privacy'

export default {
  app,
  certificate,
  node,
  home,
  chain,
  system,
  camanage,
  configmanage,
  excellent,
  expansionDemo,
  datamigration,
  crossChain,
  oracleManagement,
  contractdetector,
  encryption,
  hibe,
  bulletproofs,
  chatrobot,
  spvlightnodes,
  agileTest,
  privacy
}
